import { linkItems } from "@/components/Header/types/LinkItemsCollection";

export const useRedirectToLogin = (): void => {
    const {$router} = useNuxtApp();
    const nuxtConfig = useAppConfig();
    const login = nuxtConfig.login;
    let url = linkItems.login.routerPath;

    if (login.welcomeScreenEnabled) {
        url = linkItems.logInWelcomeScreen.routerPath;
    }

    void $router.push(url);
}